import { CloseOutlined, DeleteTwoTone, EditTwoTone, EyeTwoTone } from '@ant-design/icons';
import { Button, Chip, IconButton, Popover, Stack, Tooltip, Typography } from '@mui/material';
import CusPopover from 'components/CusPopover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { toDefaultMicDateFormat } from 'utils/common';
import PreviewIcon from '@mui/icons-material/Preview';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { red } from '@mui/material/colors';
import { BC_TYPE } from '../constant';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useTheme } from '@mui/material/styles';
import { Button2 } from 'components/Button';

const ArrowRightIcon = [
  {
    headerName: '',
    field: 'ArrowRightIcon',
    width: 10,
    sortable: false,
    disableColumnMenu: true,
    renderCell: () => <KeyboardArrowRightIcon sx={{ color: ThemeColor }} />
  }
];

const ThemeColor = () => {
  const theme = useTheme();
  return theme.palette.primary[400];
};

export const sharedMainGridColumns = ({ currentBctype, t, handleToDetails, isBatchUpdate, project }) => {
  const micColumns1 =
    currentBctype === BC_TYPE.MIC || currentBctype === BC_TYPE.PCF || currentBctype === BC_TYPE.VPB || currentBctype === BC_TYPE.VPK
      ? [
          {
            headerName: t('PRODUCT_NO'),
            field: 'ProductNo',
            width: 140
          }
        ]
      : [];
  const alwColumns =
    currentBctype === BC_TYPE.ALW
      ? [
          {
            headerName: t('SUB_CATEGORY'),
            field: 'Subcategory',
            width: 100
          }
        ]
      : [];
  const micColumns2 =
    currentBctype === BC_TYPE.MIC || currentBctype === BC_TYPE.PCF || currentBctype === BC_TYPE.VPB || currentBctype === BC_TYPE.VPK
      ? [
          {
            headerName: t('INSPECT_DATE'),
            field: 'RsinspectionDate',
            width: 140,
            renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.RsinspectionDate)}</span>
          },
          {
            headerName: t('CASTING_DATE'),
            field: 'CastingDate',
            width: 140,
            renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.CastingDate)}</span>
          },
          {
            headerName: t('SECOND_CASTING_DATE'),
            field: 'SecondCastingDate',
            width: 140,
            renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.SecondCastingDate)}</span>
          },
          {
            headerName: t(
              currentBctype === BC_TYPE.VPB || currentBctype === BC_TYPE.VPK ? 'WATERPROOF_INSTALLATION_DATE' : 'INTERNAL_FINISH_DATE'
            ),
            field: 'InternalFinishDate',
            width: 140,
            renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.InternalFinishDate)}</span>
          }
        ]
      : [];

  return [
    {
      headerName: t('DISPOSED'),
      field: 'Dispose',
      width: 100,
      renderCell: ({ row }) =>
        row.Dispose === 1 ? (
          <Chip
            sx={{
              bgcolor: '#fae8e8',
              borderRadius: '11px',
              color: '#ff6060'
            }}
            size="small"
            label={
              <Typography variant="body2" fontWeight={600}>
                {t('DISPOSED')}
              </Typography>
            }
          />
        ) : (
          <></>
        )
    },
    {
      headerName: 'A.S.N.',
      field: 'ASN',
      width: 200
    },
    {
      headerName: t('RFID_TAG_NO'),
      field: 'RfidtagNo',
      className: 'cell-center',
      width: 250
      // renderCell: ({ row }) => {
      //   return (
      //     <Typography
      //       sx={{ cursor: 'pointer' }}
      //       variant={!isBatchUpdate ? 'subtitle1' : 'body2'}
      //       {...(!isBatchUpdate ? { role: 'button', color: 'primary', onClick: () => handleToDetails(row.Id) } : {})}
      //     >
      //       {row.RfidtagNo}
      //     </Typography>
      //   );
      // }
    },
    {
      headerName: t('SERIAL_NO'),
      field: 'SerialNo',
      width: 200
    },
    ...(currentBctype === BC_TYPE.MIC || currentBctype === BC_TYPE.PCF || currentBctype === BC_TYPE.VPB || currentBctype === BC_TYPE.VPK
      ? [
          {
            headerName: t('LICENSE_PLATE_NO'),
            field: 'LicensePlateNo',
            width: 150
          },
          {
            headerName: t('T_PLATE_NO'),
            field: 'BatchNo',
            width: 150
          },
          {
            headerName: t('GPS_DEVICE_ID'),
            field: 'GpsDeviceId',
            width: 150
          }
        ]
      : [
          {
            headerName: t('BATCH_NO'),
            field: 'BatchNo',
            width: 150
          }
        ]),
    ...(currentBctype === BC_TYPE.ALW && project?.ProjCode === 'MTEST'
      ? []
      : [
          {
            headerName: t('CATEGORY'),
            field: 'Category',
            width: 100
          }
        ]),
    ...alwColumns,
    ...micColumns1,
    {
      headerName: t('MANUFACTURING_DATE'),
      field: 'ManufacturingDate',
      width: 140,

      renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.ManufacturingDate)}</span>
    },
    ...micColumns2,
    {
      headerName: t('DELIVERY_DATE'),
      field: 'DeliveryDate',
      width: 140,

      className: 'cell-right',
      renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.DeliveryDate)}</span>
    },

    {
      headerName: t('SITE_ARRIVAL_DATE'),
      field: 'SiteArrivalDate',
      width: 140,

      className: 'cell-right',
      renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.SiteArrivalDate)}</span>
    },

    {
      headerName: t('INSTALLATION_DATE'),
      field: 'SiteInstallationDate',
      width: 140,

      className: 'cell-right',
      renderCell: ({ row }) => <span>{toDefaultMicDateFormat(row?.SiteInstallationDate)}</span>
    },
    ...(!isBatchUpdate ? ArrowRightIcon : [])
  ];
};

export const sharedSummaryGridColumns = ({ t }) => [
  {
    headerName: t('NUMBER_COMPLETED'),
    field: 'Step',
    width: 400,
    sortable: false
  },
  {
    headerName: t('THIS_MONTH'),
    field: 'ThisMonth',
    width: 140,
    sortable: false
  },
  {
    headerName: t('THIS_WEEK'),
    field: 'ThisWeek',
    width: 140,
    sortable: false
  },
  {
    headerName: t('CUMULATIVE'),
    field: 'Total',
    width: 140,
    sortable: false
  }
];

export const sharedDetailGridColumns = ({ t, openSiderbar, handleEdit, currentLang, handleViewAuditTrail }) => [
  {
    headerName: t('STEP_CODE'),
    field: 'Step',
    width: 200
  },
  {
    headerName: t('STEP_NAME'),
    field: 'StepName',
    width: 200,
    renderCell: ({ row }) => <Typography>{row[`StepDesc${currentLang}`]}</Typography>
  },
  {
    headerName: t('COMPLETED'),
    field: 'IsCompleted',
    width: 200,
    renderCell: ({ row }) => (row.IsCompleted ? <CheckCircleIcon color="success" /> : <CancelIcon sx={{ color: red[500] }} />)
  },
  {
    headerName: t('ACTION'),
    field: 'Action',
    width: 200,
    renderCell: ({ row }) => (
      <Button
        onClick={() => {
          handleEdit({ Step: row.Step, Portion: row.Portion, AllowField: row.AllowField }, row?.CanUpdate);
        }}
        variant="outlined"
        startIcon={<PreviewIcon />}
      >
        {row?.CanUpdate ? t('EDIT') : t('VIEW')}
      </Button>
    )
  }
];

export const userAdminGridColumns = ({ t, openSiderbar, handleEdit, upperCaseLang }) => [
  {
    headerName: t('USER'),
    field: 'UserName',
    width: 200,
    renderCell: ({ row }) => (
      <Stack>
        <Typography variant="body1">{row.UserName}</Typography>
        <Typography
          variant="body2"
          sx={{
            opacity: 0.5
          }}
        >
          {row.Email}
        </Typography>
      </Stack>
    )
  },
  {
    headerName: t('FULL_NAME'),
    field: 'FullName',
    width: 200
  },
  {
    headerName: t('MOBILE'),
    field: 'PhoneNumber',
    width: 200
  },
  {
    headerName: t('COMPANY'),
    field: 'CompanyName',
    width: 200,
    renderCell: ({ row }) => (
      <Typography>
        {row?.ProjCode ? `${row?.ProjCode} - ` : ''} {row[`CompanyName${upperCaseLang}`] + (row?.RefCode ? ` (${row?.RefCode})` : '')}
      </Typography>
    )
  },

  {
    headerName: t('TEAM'),
    field: 'Team',
    width: 200
  },
  // {
  //   headerName: t('USER_ROLE'),
  //   field: 'UserRole',
  //   width: 200
  // },
  {
    headerName: t('STATUS'),
    field: 'Status',
    width: 200,
    renderCell: ({ row }) => <Chip label={row.Status} color="success" />
  },
  {
    headerName: t('ACTION'),
    field: 'Action',
    width: 200,
    renderCell: ({ row }) => (
      <>
        <Button2
          onClick={() => {
            handleEdit(row.UserId);
          }}
          startIcon={<PreviewIcon />}
          text={t('EDIT')}
        />
        {/* <CusPopover shouldClose={openSiderbar} content={<MoreVertIcon />} id={`${row.stepCode}-popover`}>
          <Stack spacing={1}>
            <Button onClick={() => {}} variant="outlined" startIcon={<MenuBookIcon />}>
              {t('AUDIT_TRAIL')}
            </Button>
          </Stack>
        </CusPopover> */}
      </>
    )
  }
];
